import React, { Component } from "react";

export default class SupplierDash extends Component {
  render() {
    return (
      <div className="container">
        <h1>Welcome Supplier</h1>
      </div>
    );
  }
}
